<template>
  <el-card>
    <UserBeastCoin />
  </el-card>
</template>

<script>
// import GrantStat from '@/views/config/spins-consume/compents/grant-stat.vue'
import UserBeastCoin from '@/views/config/user-spins/comments/user-beastcoin.vue'
export default {
  name: 'Index',
  components: {
    // GrantStat,
    UserBeastCoin
  }
}
</script>

<style scoped>
.mtop{
  margin-top: 20px;
}
</style>
